import { inject } from 'vue';

export default function useEmitter() {
  return inject('emitter');
}
